import { render, staticRenderFns } from "./MediaGroupNew.vue?vue&type=template&id=8bb7d40e&"
import script from "./MediaGroupNew.vue?vue&type=script&lang=js&"
export * from "./MediaGroupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports